import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Button } from '@mui/material';
import logo from './logo.svg';
import './App.css';

// Admin Components
import AdminLayout from './admin/AdminLayout';
import AdminLogin from './admin/AdminLogin';
import Dashboard from './admin/Dashboard';
import ProductList from './admin/ProductList';
import NewsList from './admin/NewsList';
import NewsForm from './admin/NewsForm';
import ProductForm from './admin/ProductForm';
import UpdateProductForm from './admin/UpdateProductForm';

// User Components
import UserLayout from './pages/UserLayout';
import Home from './pages/Home';
import Products from './pages/Products';
import News from './pages/News';
import About from './pages/About';
import Contact from './pages/Contact';
import Service from './pages/Service';
import Gallery from './pages/Gallery';
import { useEffect, useState } from 'react';
import LoadingInterior from './components/Loading';
import useProducts from './data/productdata';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './admin/ProtectedRoute';
import FixedContact from './components/FixedContact';

function App() {
  const { products, fetchProducts } = useProducts();
  const [loading, setLoading] = useState(() => !localStorage.getItem('hasVisited'));

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
        localStorage.setItem('hasVisited', 'true');
      }, 2000);
    }
  }, [loading]);

  return (
    <>
      {loading ? (
        <LoadingInterior />
      ) : (
        <BrowserRouter>
  <ScrollToTop />
  <FixedContact/>
  <Routes>
    {/* Admin Routes */}
    <Route path="admin" element={<AdminLayout />}>
  <Route path="login" element={<AdminLogin />} />
  <Route path="dashboard" element={<Dashboard />} />
  <Route path="products" element={<ProductList />} />
  
  {/* Protected Product Routes */}
  <Route path="products/new" element={
    <ProtectedRoute>
      <ProductForm />
    </ProtectedRoute>
  } />
  <Route path="products/edit/:id" element={
    <ProtectedRoute>
      <UpdateProductForm />
    </ProtectedRoute>
  } />
  
  {/* Protected News Routes */}
  <Route path="news" element={<NewsList />} />
  <Route path="news/new" element={
    <ProtectedRoute>
      <NewsForm />
    </ProtectedRoute>
  } />
</Route>


    {/* User Routes */}
    <Route path="/" element={<UserLayout />}>
      <Route index element={<Home />} />
      <Route path="products" element={<Products />} />
      <Route path="news" element={<News />} />
      <Route path="about" element={<About />} />
      <Route path="contact" element={<Contact />} />
      <Route path="services" element={<Service />} />
      <Route path="gallery" element={<Gallery />} />
    </Route>
  </Routes>
</BrowserRouter>
      )}
    </>
  );
}

export default App;
